import { Injectable } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FormEditor, FIELD_TYPES } from './../../models/editors/form-editor.base.model';

import * as appConfig from '../../app.config';
import { FormField } from './../../models/forms/formField.model';
import { NgOption } from '@ng-select/ng-select';
@Injectable()
export class FormControlService {

  constructor() { }

  processField(field: any, group: any, value: any): void {

    const copiedField = this._simpleClone(field);
    const fieldKey = copiedField.key;
    const formGroup = {};

    let fieldGroup = group;

    if (copiedField.formGroup) {
      fieldGroup = formGroup;
    }

    if (copiedField.isMultilang) {
      appConfig.languages.forEach(lang => {
        const control = new FormControl(
          this._getValue(copiedField, value, lang),
          copiedField.validators
        );
        fieldGroup[fieldKey + '_' + lang] = control;
      });
    } else {
      fieldGroup[fieldKey] = new FormControl(
        this._getValue(copiedField, value),
        copiedField.validators
      );
    }

    if (copiedField.formGroup) {
      if (group[copiedField.formGroup] as FormGroup) {
        for (const control in formGroup) {
          if (!formGroup.hasOwnProperty(control)) {
            continue;
          }
          group[copiedField.formGroup].registerControl(
            control,
            formGroup[control]
          );
        }
      } else {
        if (copiedField.orderable) {
          formGroup['_joinData']['entityorder'] = new FormControl([1, 2, 3]);
        }
        group[copiedField.formGroup] = new FormGroup(formGroup);
      }
    }
  }

  toFormGroup(fieldsConfig: FormEditor<any>[], value: any) {
    const group: any = {};

    fieldsConfig.forEach(field => {
      console.log(field);

      if (field.fields) {
        field.fields.forEach(fld => {
          this.processField(fld, group, value);
        });
      }
      this.processField(field, group, value);

    });
    return new FormGroup(group);
  }

  /* transform the data so we can dynamically output through generic component template */
  toTemplateInput(fieldsConfig: FormEditor<any>[], value: any) {
    const templateFields: any = {};
    templateFields['unilang'] = [];

    appConfig.languages.forEach(lang => {
      templateFields[lang] = [];
      fieldsConfig.forEach(field => {
        const copiedField = this._simpleClone(field);
        if (copiedField.isMultilang) {

          if (copiedField.entityMultilang) {
            copiedField.entity = copiedField.entityMultilang[copiedField.entityMultilangKey + '_' + lang];
          }

          copiedField.langKey = lang; // set field language
          const fieldKey = copiedField.key;
          copiedField.key = fieldKey + '_' + lang;

          copiedField.value = this._getValue(copiedField, value);
          if (copiedField.boundTo) {
            const bindedField = fieldsConfig.find(
              boundField => boundField.key === copiedField.boundTo
            );
            copiedField.hidden = !this._getValue(bindedField, value);
            if (bindedField.isMultilang) {
              copiedField.boundTo = bindedField.key + '_' + lang;
              copiedField.hidden = !this._getValue(bindedField, value, lang);
            }
          }
          templateFields[lang].push(copiedField);
        } else if (copiedField.containedMultilang) {
          copiedField.langKey = lang; // set field language
          templateFields[lang].push(copiedField);
        }
      });
    });

    fieldsConfig.forEach(field => {
      const copiedField = this._simpleClone(field);
      copiedField.value = this._getValue(copiedField, value);
      if (copiedField.boundTo) {
        const bindedField = fieldsConfig.find(
          boundField => boundField.key === copiedField.boundTo
        );
        copiedField.hidden = !this._getValue(bindedField, value);
      }
      if (!copiedField.isMultilang && !copiedField.containedMultilang) {
        templateFields['unilang'].push(copiedField);
      }
    });

    return templateFields;
  }

  public getFormFieldsModel(lang: string, index: number): FormField {
    return new FormField({
      id: '',
      label: '',
      type: '',
      defaultValue: true,
      required: true,
      fieldoptions: [],
      position: 99999,
      language: lang,
      fieldIndex: index
    });
  }

  private _simpleClone(obj: any): any {
    return Object.assign({}, obj);
  }

  private _getValue(field: any, formValue: any, lang?: string): any {

    if (field.value !== undefined) {
      return field.value;
    }

    let value: any;

    let key = field.key;
    if (lang) {
      key = key + '_' + lang;
    }
    if (formValue && formValue[key] !== undefined) {
      value = formValue[key];
    } else {

      if (field.defaultValue !== undefined) {
        value = field.defaultValue;
      } else {
        if (FIELD_TYPES.array.includes(field.controlType)) {
          value = [];
        } else if (FIELD_TYPES.boolean.includes(field.controlType)) {
          value = false;
        } else {
          value = '';
        }
      }
    }
    return value;
  }

  public getDropdownValues(displayedField: string, list: Array<any>): Array<NgOption> {
    const options: Array<NgOption> = [];
    list.forEach(item => {
      const option: NgOption = { value: item.id, text: item[displayedField + '_' + appConfig.languages[0]] };
      options.push(option);
    });
    return options;
  }

}
